import AdjustmentsList from './AdjustmentsList';

export default AdjustmentsList;
